angular.module('bizmetryApp')
  .service('AgentLogsService', ['$mdDialog', function ($mdDialog) {

    this.openLogsDialog = function(event,agent) {
      return $mdDialog.show({
        controller: 'AgentLogsDialogController',
        templateUrl: 'profile/tabs/agents/logs/agent-logs-dialog.html',
        parent: angular.element(document.body),
        multiple: true, // permite stacking sobre otro diálogo abierto
        clickOutsideToClose: true,
        escapeToClose: false,
        locals: {
          agent: agent
        }
      });
    };

    

  }]);

